// import imageOne from '../../assets/media/whatIsMoneyTree.c5ec1bef2827d96e7995.png'
// import imageTwo from '../../assets/media/contributions.41d601dac33f4f5efa9b.png'
// import imageThree from '../../assets/media/affiliateCommission.4afa8086f0d057dfbea9.png'
// import imageFour from '../../assets/media/questions.76be8ca4625ae52a9007.png'
// import imageFive from '../../assets/media/tree.55af3eee6694b7119069.png'
// import guard from '../../assets/media/guard.png'

// import svgOne from '../../assets/media/bnb.560b9ab6dbce8724c4b21c9c10bc8104.svg'
// import svgTwo from '../../assets/media/src-white-logo.png'
export default function Hero() {
    return (
        <section className="hero bg_img" data-background="assets/images/bg/hero.jpg">
        <div className="container">
          <div className="row container">
          <div className="col-xl-2 col-lg-12">
            </div>
            <div className="col-xl-8 col-lg-8">
              <div style={{textAlign:'center', alignItems:'center', justifyContent:'center', marginTop:'-130px'}} className="hero__content">
                <h2 className="hero__title">
                  {/* <span className="text-white font-weight-normal">
                    Invest for Future in Stable Platform
                  </span>{" "} */}
                  <b className="base--color f-size-19">Shear With Fiends & Make Fast Money</b>
                </h2>
                <p className="text-white f-size-16 mt-3">
                  IWe
                  provide you with the most necessary features that will make your
                  experience better. Not only we guarantee the fastest and the most
                  exciting returns on your investments, but we also guarantee the
                  security of your investment.
                </p>
                <a href="#0" className="cmn-btn text-uppercase font-weight-600 mt-4">
                  Sign Up
                </a>
              </div>
            </div>
            <div className="col-xl-2 col-lg-12">
            </div>
          </div>
        </div>
      </section>
    );
}